module.exports = __webpack_public_path__ + "img/logoshort.d3f23b77.png";